import * as poolFactory from '../abis/poolFactory.json';
import * as tokenFaucet from '../abis/tokenFaucet.json';

export const config = {
    poolFactoryAbi: poolFactory.default,
    poolFactoryAddress: "0xAd7d0E96dD62A3EF006ded273E5EB020D91c7754",
    tokenFaucetAbi: tokenFaucet.default,
    tokenFaucetAddress: "0x04eDe85E8E04cEAE771ADC43b4D6b5e6c1ffBC14",
}
